import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { CertificadoComunicacao } from '../../model/certificadoComunicacao';
import { ProdutoGar } from '../../model/produtoGar';

@Injectable()
export class CertificadoComunicacaoService {

  private options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };

  constructor(private http: HttpClient) { }

  listar(organizacaoId: number): Promise<CertificadoComunicacao[]> {
    return this.http.get(environment.backendBaseUrl + `/manager/certificadocomunicacao/organizacao/${organizacaoId}`, this.options)
      .toPromise()
      .then(response => response as CertificadoComunicacao[])
      .catch(this.handleError);
  }

  listarProdutos(id: number): Promise<ProdutoGar[]> {
    return this.http.get(environment.backendBaseUrl + `/manager/certificadocomunicacao/listarProdutos/${id}`, this.options)
      .toPromise()
      .then(response => response as ProdutoGar[])
      .catch(this.handleError);
  }

  private handleError(error: any): Promise<any> {
    console.error('OCORREU UM ERRO:', error.error.message);
    return Promise.reject(error.error.message || error);
  }
}
